import { useContext } from 'react';
import { ComposersTableContext } from '../components/ComposersTableProvider';
export const useComposersTable = () => {
    const context = useContext(ComposersTableContext);
    if (!context) {
        throw new Error('useComposersTable hook must be used as a child to <ComposersTableProvider />');
    }
    return context;
};
